import axios from "axios";
import { printerFormatDefault } from "@/constants/printer";

export default {
  eventPreflight(payload) {
    return axios.post("/v2/printer/evento/preflight", payload);
  },
  eventPrint(payload) {
    return axios.post("/v2/printer/evento", payload);
  },
  eventStatus(jobId, session) {
    if (!/^[A-Za-z0-9_-]{1,128}$/.test(jobId))
      throw new Error("Trabalho de impressão inválido.");
    return axios.get(`/v2/printer/evento/${encodeURIComponent(jobId)}`, {
      headers: {
        "x-photonow-event-attendance": session.attendanceId,
        "x-photonow-event-reservation": session.reservationToken,
      },
    });
  },
  devicePrint(
    fotosURL,
    tipoFoto,
    featureFlag = "",
    formato = printerFormatDefault,
    offset = { x: 0, y: 0 },
    correlation = null
  ) {
    const safeId = (value) =>
      typeof value === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(value);
    const identifiers =
      correlation &&
      safeId(correlation.jobId) &&
      safeId(correlation.purchaseId) &&
      safeId(correlation.totemId)
        ? correlation
        : null;
    return axios.post("/v2/printer", {
      fotosUrl: fotosURL,
      tipo: tipoFoto,
      feature_flag: featureFlag,
      formato: formato,
      x: offset.x,
      y: offset.y,
      ...(identifiers && {
        jobId: identifiers.jobId,
        purchaseId: identifiers.purchaseId,
        totemId: identifiers.totemId,
      }),
    });
  },
};
